import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { L10nTranslationService } from 'angular-l10n';
import { filter, firstValueFrom } from 'rxjs';
import { SimpleDialogComponent } from '../simple-dialog/simple-dialog.component';
import { ISimpleDialog } from '../simple-dialog/simple-dialog.interface';
import { WINDOW } from '../window-injection-token';

@Injectable()
export class PromptUpdateService {
  private updates = inject(SwUpdate);
  dialog = inject(MatDialog);
  private translation = inject(L10nTranslationService);
  private window = inject<Window>(WINDOW);


  checkUpdates(): void {
    console.log('checking ngsw updates...');
    this.updates.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe((evt) => void this.handleConfirmAndReload(evt));
  }

  async handleConfirmAndReload(evt: VersionReadyEvent): Promise<void> {
    console.log(
      'Service worker update available. current: ',
      evt.currentVersion,
      'available:',
      evt.latestVersion
    );
    if (await this.showConfirmDialog('sw-update-prompt')) {
      await this.updates.activateUpdate();
      this.reload();
    }
  }

  reload(): void {
    this.window.location.reload();
  }

  async showConfirmDialog(text: string): Promise<boolean> {
    const data: ISimpleDialog = {
      body: (this.translation?.translate(text) || text) as string,
      confirm: true,
    };
    const dialogRef = this.dialog.open(SimpleDialogComponent, { data });
    return (await firstValueFrom(dialogRef.afterClosed())) as boolean;
  }
}
